import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

interface BarcodeSvgProps {
  value: string;
  width?: number;
  height?: number;
  fontSize?: number;
  displayValue?: boolean;
}

export function BarcodeSvg({
  value,
  width = 1.2,
  height = 36,
  fontSize = 11,
  displayValue = true,
}: BarcodeSvgProps): JSX.Element {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (svgRef.current && value) {
      try {
        JsBarcode(svgRef.current, value, {
          format: "CODE128",
          width,
          height,
          displayValue,
          fontSize,
          margin: 0,
          background: "transparent",
        });
      } catch (err) {
        console.warn("Failed to render barcode:", err);
      }
    }
  }, [value, width, height, fontSize, displayValue]);

  return <svg ref={svgRef} style={{ maxWidth: "100%", height: "auto" }} />;
}
